import { taskNarrationCopy } from "@/features/chat/phase1/taskNarrationCopy";
import { taskNarrationMeta } from "@/features/chat/phase1/taskNarrationMeta";
import NarrationText from "./NarrationText";

export default function TaskNarration({ task }) {
  const copy = taskNarrationCopy(task);
  const meta = taskNarrationMeta(task);
  return (
    <NarrationText text={copy} meta={meta} error={Boolean(task.blocker)} />
  );
}
